import { useTranslation } from 'react-i18next'

import { ROUTE_UI_SECTION_NAME } from '../../../../../constants/route'
import {
  useInitData,
  useNotification,
  useSectionPermissions,
} from '../../../../../hooks'
import {
  getRequestPostFormInitialValues,
  NewsboardPostFormModal,
} from '../../../../Newsboard'
import { getPostCreationSuccessNotification } from '../../../../Post'
import { REQUEST_PROFILE_TAB_POSTS } from '../../../RequestProfile.constants'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import { QA_NAME_REQUEST_PROFILE_TAB_POSTS_ADD_NEW } from '../../RequestProfileTabPosts.constants'

export function useRequestPostCreation() {
  const { t } = useTranslation()

  const { handleAddSuccessNotification } = useNotification()

  const { availableSections } = useInitData()

  const { handleCloseModal, handleLoadCounters, requestData, setModal } =
    useRequestProfileContext()

  const { canCreate } = useSectionPermissions({
    sectionName: ROUTE_UI_SECTION_NAME.newsboard,
  })

  function handleOpenCreation({ onReloadList }) {
    const { getInitialValues, recipientInitialValues } =
      getRequestPostFormInitialValues(requestData)

    function handleSuccess({ title, uuid }) {
      handleCloseModal()

      handleAddSuccessNotification(
        getPostCreationSuccessNotification({
          availableSections,
          t,
          title,
          uuid,
        })
      )

      onReloadList?.()
      handleLoadCounters?.([REQUEST_PROFILE_TAB_POSTS])
    }

    setModal(
      <NewsboardPostFormModal
        getInitialValues={getInitialValues}
        recipientInitialValues={recipientInitialValues}
        onClose={handleCloseModal}
        onSuccess={handleSuccess}
      />
    )
  }

  return {
    addNewQaName: QA_NAME_REQUEST_PROFILE_TAB_POSTS_ADD_NEW,
    addNewText: t('RequestProfileTabPosts.AddNewPostBtnKey'),
    canCreate,
    onCreate: handleOpenCreation,
  }
}
